import { COLORS } from '../config/constants';

const STYLE_ID = 'handsontable-dynamic-styles';

export function createDynamicStyles(): void {
  // Remove existing styles if present
  const existingStyle = document.getElementById(STYLE_ID);
  if (existingStyle) {
    existingStyle.remove();
  }

  const style = document.createElement('style');
  style.id = STYLE_ID;

  const css = `
    /* Shipment with events */
    .shipment-with-events {
      position: relative;
    }
    .handsontable tbody tr:hover .shipment-with-events {
      background-color: #d4edda !important;
      border-left-color: #28a745 !important;
    }

    /* Tracking highlights */
    .tracking-highlight {
      background-color: ${COLORS.trackingHighlight} !important;
      border-left: 3px solid ${COLORS.trackingBorder} !important;
    }

    /* Tooltips */
    .tracking-tooltip {
      position: absolute;
      bottom: 70%;
      left: 50%;
      transform: translateX(-50%);
      background: #ffffff;
      color: #1f2937;
      border-radius: 8px;
      font-size: 11px;
      z-index: 1000 !important;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      margin-bottom: 8px;
      padding: 8px;
      border: 1px solid #e5e7eb;
    }
    .tracking-tooltip::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid #ffffff;
    }

    .tracking-tooltip-reversed {
        position: absolute;
        top: 70%;
        left: 50%;
        transform: translateX(-50%);
        background: #ffffff;
        color: #1f2937;
        border-radius: 8px;
        font-size: 11px;
        z-index: 1000 !important;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.2s;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        margin-top: 8px;
        padding: 8px;
        border: 1px solid #e5e7eb;
      }
      .tracking-tooltip-reversed::after {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #ffffff;
      }
      

    .handsontable td {
      position: relative;
    }
    .handsontable td:hover .tracking-tooltip {
      opacity: 1 !important;
      pointer-events: auto !important;
    }

    .handsontable td:hover .tracking-tooltip-reversed {
      opacity: 1 !important;
      pointer-events: auto !important;
    }

    /* Tooltip table */
    .tooltip-table {
      border-collapse: collapse;
      width: 100%;
    }
    .tooltip-table td {
      padding: 6px 8px;
      white-space: nowrap;
      border-bottom: 1px solid #e5e7eb;
      vertical-align: middle;
    }
    .tooltip-field {
      color: #6b7280;
      font-weight: 700;
      font-size: 10px;
      text-align: center;
      background: #f9fafb;
      border-right: 1px solid #e5e7eb;
    }
    .tooltip-date {
      color: #2563eb;
      font-weight: 600;
      font-size: 12px;
    }
    .tooltip-location {
      color: #374151;
    }
    .tooltip-vessel {
      color: #374151;
    }
    .tooltip-source {
      color: #6b7280;
      font-size: 10px;
      font-style: italic;
    }
    .tooltip-icon {
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
      margin-right: 4px;
    }
    .tooltip-icon svg {
      display: block;
    }

    /* Table headers */
    .handsontable.ht_clone_top th,
    .handsontable.ht_clone_top_left_corner th,
    .handsontable.ht_clone_left th,
    .handsontable thead th {
      font-weight: bold !important;
      color: black;
      background-color: ${COLORS.headerBg};
    }
    .handsontable.ht_clone_top th:not(.rowHeader),
    .handsontable thead th:not(.rowHeader) {
      font-weight: bold !important;
      color: black;
    }
    th.ht__highlight {
      background-color: ${COLORS.headerHighlight} !important;
      color: white !important;
    }

    /* Row headers */
    .ht__row-header {
      text-align: center;
      vertical-align: middle;
      padding: 4px 8px;
    }
    .ht__row-header svg {
      vertical-align: middle;
    }
  `;

  style.textContent = css;
  document.head.appendChild(style);
}

export function removeDynamicStyles(): void {
  const existingStyle = document.getElementById(STYLE_ID);
  if (existingStyle) {
    existingStyle.remove();
  }
}
